import React from "react";
import { formatPhoneNumber } from './Common'

/**
 * @desc created pure component for setting phone number format
 * for this component - input 10 integer number and output will be with 999-999-9999 format
 */
class PhoneNumber extends React.Component {
  
    render() {
      return <React.Fragment>{formatPhoneNumber(this.props.phoneNumber)}</React.Fragment>
    }
}

export default PhoneNumber;